<template>
  <div class="agreement">
    <div class=""><!--橙鹿用户增值服务协议--></div>
    <div>
      <div>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">尊敬</span
          ><span style="">的</span
          ><span style="">橙鹿</span
          ><span style="">APP用户：</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">欢迎您</span
          ><span style="">使用</span
          ><span style="">橙鹿</span
          ><span style=""
            >用户增值收费服务，请仔细阅读以下全部内容。</span
          ><span style=" font-weight: bold"
            >未成年人应在法定监护人陪同下审阅和履行，未成年人行使和履行本协议项下的权利和义务视为已获得法定监护人的认可。</span
          ><span style=""
            >如果您不同意本协议的任一或全部条款内容，请不要以确认的形式（包括但不限于点击、进入购买程序等）进行下一步操作或使用本协议项下服务。</span
          ><span style=" font-weight: bold"
            >当您确认接受本协议或开始使用本协议项</span
          ><span style=" font-weight: bold">下</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台增值服务时，即表示您</span
          ><span style=" font-weight: bold">与</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >【平台开发运营主体为橙鹿教育科技（湖北）有限公司】已达成协议关系，并自愿接受和</span
          ><span style=" font-weight: bold">遵守</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台提供服务涉及的包括本协议在内的所有服务规范及相关子协议、管理规范等。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >第一条 关于本协议的相关说明</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">1. 本协议与《</span
          ><span style="">橙鹿</span
          ><span style="">用户服务协议》、《</span
          ><span style="">橙鹿</span
          ><span style="">隐私政策》以及与</span
          ><span style="">本服务</span
          ><span style="">相关</span
          ><span style="">的</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台规则、补充协议、附加条款等共同构成双方均须遵守的内容。本协议中未约定事项以《</span
          ><span style="">橙鹿</span
          ><span style="">用户服务协议》、《</span
          ><span style="">橙鹿</span
          ><span style=""
            >隐私政策》中的约定为准，本协议与前述协议存在冲突的，以本协议为准。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">2. </span
          ><span style="">橙鹿</span
          ><span style=""
            >平台有权变更本协议内容，一旦本协议内容发生变更的，</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台将在相应页面、站内公告或以其他合理方式进行通知，请您仔细阅读。如果您不同意变更的内容的，您可以选择停止使用该用户增值服务。如您继续使用用户增值服务的，则视为您已经同意变更的全部内容。更新后的协议从</span
          ><span style="">在</span
          ><span style="">橙鹿</span
          ><span style="">平台公示之日起生效。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >第二条 增值服务说明</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">1.【服务的获得】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（1）您如果需要使用和</span
          ><span style="">享受</span
          ><span style="">橙鹿</span
          ><span style="">增值服务，首先</span
          ><span style="">应注册成为</span
          ><span style="">橙鹿</span
          ><span style=""
            >用户。登录您的用户账号后下单购买相应的学历产品，此时可选择是否开通该项增值服务。</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台目前提供的增值服务仅限于“自学考试非全日制助学班”和“成人高等学历教育班”两种学历产品，具体信息可</span
          ><span style="">询问</span
          ><span style="">橙鹿</span
          ><span style="">平台客服人员。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（2）橙鹿可能会根据用户及市场的需求、产品及服务类型的变化等各种因素，对现有增值服务种类、功能、价格、权益进行调整以及不断推出新的增值服务种</span
          ><span style=""
            >类。具体增值服务种类及服务内容及费用标准以相关服务页面公布、实际提供的内容为准。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">2.【服务的开通】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">在您开通</span
          ><span style="">橙鹿</span
          ><span style="">“</span
          ><span style="">橙鹿</span
          ><span style="">“</span
          ><span style="">增值服务后，</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台客服人员将通过平台内即时通讯软件或</span
          ><span style="">您注册</span
          ><span style=""
            >预留的手机号、电子邮箱、QQ号、</span
          ><span style="">微信等</span
          ><span style=""
            >联系方式，发送本项增值服务所提供的在线视频学习中心的账号和密码，发出手机短信、电子邮件或网络</span
          ><span style="">讯息</span
          ><span style="">时视为开通本项增值服务。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >3.【学习中心账号的使用和安全】</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（1）您应自行负责并妥善、正确地保管、使用、维护您学习中心账号和密码，并对您的账号和密码采取必要和有效的保密措施。</span
          ><span style="">非</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台法定过错导致的任何遗失、泄露、被篡改、被盗以及其他因保管、使用、维护不当而造成的损失，您应自行承担。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（2）您的学习中心账号仅限您本人出于非商业目的进行使用。</span
          ><span style="">您不得</span
          ><span style=""
            >将学习中心账号及权益转让、赠与、售卖、租借、分享给第三方，否则因上述行为导致账号遗失、泄露、被篡改、被盗等损失的，或因多终端登录、异地登录等情况触发安全</span
          ><span style="">风控导致</span
          ><span style=""
            >账号异常，甚至账号被封的损失的，均应当由您自行承担。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">4.【使用原则及规范】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（1）使用原则：您在</span
          ><span style="">使用</span
          ><span style="">橙鹿</span
          ><span style=""
            >用户增值服务过程中，应遵守宪法法律，包括但不限于《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《互联网电子公告服务管理规定》、《信息网络传播权保护条例》、《网络安全法》等有关计算机及互联网规定的法律、法规；应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度</span
          ><span style="">、</span
          ><span style=""
            >煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义</span
          ><span style="">、</span
          ><span style=""
            >宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（2）使用规范：在您</span
          ><span style="">使用</span
          ><span style="">橙鹿</span
          ><span style=""
            >用户增值服务的过程中，不得存在以下行为：</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">a.</span
          ><span style="">&nbsp;</span
          ><span style="">未经</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台明确授权，将该项用户增值服务提供的视频的全部或部分进行复制、下载、上传、修改、编目排序、翻译、发行、开发、转让、销售、展示、传播、合成、嵌套、链接、创作衍生作品、进行商业开发或推广等；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">b. </span
          ><span style="">对</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台用于保护用户增值服务的任何安全措施技术进行破解、更改、反操作、篡改或其他破坏；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">c. </span
          ><span style="">未经</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台事先书面同意，删除用户增值服务内容上的任何所</span
          ><span style="">有权或知识产权声明或标签。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >（3）您理解、知悉并同意，如</span
          ><span style=" font-weight: bold">您存在或经</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台独立判断后认为</span
          ><span style=" font-weight: bold">您存在</span
          ><span style=" font-weight: bold"
            >任何违反国家法律法规或监管政策、违反本协议或</span
          ><span style=" font-weight: bold">有损</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台及其关联公司的声誉、利益的行为的，</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台有权删除或屏蔽相关链接或内容、中断或终止部分或全部用户增值服务，且您已交纳的增值服务费用将不予退还且不获得任何形式的补偿或赔偿；</span
          ><span style=" font-weight: bold">同时</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold">平台有权</span
          ><span style=" font-weight: bold">追究您相关</span
          ><span style=" font-weight: bold"
            >的法律责任。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >第三条 增值服务内容、期限及收费标准</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">1.【增值服务内容】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（1）</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台目前推出的增值服务主要内容：通过自主或委托第三方开发和运营的互联网信息平台，向付费的用户提供各类数字化视频作品以及与视频相关的文字介绍、宣传PPT、电子资料包等内容，以满足用户自学不同形式高等学历教育入学考试或期末考试所必备知识的需求。</span
          ><span style=" font-weight: bold"
            >您理解、知悉并同意：</span
          ><span style=" font-weight: bold">您仅拥有</span
          ><span style=" font-weight: bold">合法</span
          ><span style=" font-weight: bold">获得</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >增值服务的使用权，上述服务、视频产品及其衍生物的所有权或相关知识产权</span
          ><span style=" font-weight: bold">均归</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台及相关技术开发公司所有。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（2）如您自主观看学习视频期间，遇到在线直播、视频回放或资料下载等有关问题的，</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台将在合理期限内做出回复和处理。但因不可抗力或其他原因造成服务中断或停止的，</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台不承担任何责任。如您对视频教学内容、学习资料（包括电子版）的质量等不满意的，</span
          ><span style="">橙鹿</span
          ><span style="">平台将向第三</span
          ><span style="">方服务</span
          ><span style="">提供商</span
          ><span style="">反馈您</span
          ><span style=""
            >的意见，但平台对以上视频内容及资料不承担任何责任。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（3）</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台可能会根据法律规定及政策变更、公司经营变化、用户及市场需求等，对现有增值服务种类、功能、价格、权益进行调整。前述项目的调整，</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台将在相应服务页面或以其他合理方式进行通知。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">2.【服务期限】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（1）您的用户增值服务有效期限以您自行选择的学历产品对应的服务期限为准，</span
          ><span style="">自</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台向您发送在线视频学习中心账户和密码之日起算，“自学考试非全日制”学历产品对应的增值服务期限为2年，“成人高等教育”学历产品对应的增值服务期限为1年。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >（2）上述期限不</span
          ><span style=" font-weight: bold">因您未使用</span
          ><span style=" font-weight: bold"
            >或对视频的暂停、倒回等情况而延长，在有效期届满后，无论您是否使用完毕所购的服务内容，</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >将停止继续向您提供相应服务。</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold">平台</span
          ><span style=" font-weight: bold">不</span
          ><span style=" font-weight: bold"
            >因此向您退还已支付的费用且不予进行任何形式的补偿或赔偿。同时，您理解、知悉并同意，就前述付费增值服务所</span
          ><span style=" font-weight: bold"
            >提供的部分或全部视频内容，</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台有权根据自身运营政策需要，在某些特殊时段或在优惠活动中限时免费提供给其他用户观看。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >（3）您理解、知悉并同意，</span
          ><span style=" font-weight: bold">本服务</span
          ><span style=" font-weight: bold"
            >的服务期间，</span
          ><span style=" font-weight: bold">包含</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >解决故障、服务器维修、调整、升级、因第三方侵权处理等所需的合理时间，对上述情况所需使用的</span
          ><span style=" font-weight: bold">时间</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold">不</span
          ><span style=" font-weight: bold"
            >另行补偿。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">3.【收费标准和费用退还】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（1）收费标准：</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >依据您自主选择购买的不同的学历形式产品，您须承担的增值服务的费用将有所不同，具体资费以您在购买该增值服务时显示的支付页面公示价格为准。若该价格与您浏览的宣传页面标示价格不同，将</span
          ><span style="">以</span
          ><span style="">橙鹿</span
          ><span style=""
            >为您推送的支付页面商品价格为准。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（2）费用退还：</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >您购买的用户增值服务系网络商品和虚拟商品，采用先收费后服务的方式，</span
          ><span style="">您支付</span
          ><span style=""
            >的费用是您所购买的用户增值服务所对应的网络商品价格，而非预付款或者存款、定金、储蓄卡等性质，</span
          ><span style=" font-weight: bold"
            >该增值服务一经购买后不可退款（如因该服务确实存在无法修复的重大瑕疵导致您完全无法使用该服务的，本协议另有约定、法律法规要求必须退款的或</span
          ><span style=" font-weight: bold">经</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台判断后认为可以退款等除外）。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=" font-weight: bold"
            >第四条 通用条款</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">1.【个人信息保护】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">橙鹿</span
          ><span style=""
            >平台非常重视您个人信息的保护，在您使用该项用户增值服务时，您</span
          ><span style="">同意</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台按照公布的隐私政策收集、存储、使用、披露和保护您的个人信息。</span
          ><span style=" font-weight: bold">因此，</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >平台建议您完整地阅读《</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >用户服务协议》、《</span
          ><span style=" font-weight: bold"
            >橙鹿</span
          ><span style=" font-weight: bold"
            >隐私政策》，以帮助您更好地保护您的隐私权，如您不同意请不要开通或停止使用本服务。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">2.【通知和送达】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">对于</span
          ><span style="">橙鹿</span
          ><span style="">平台内</span
          ><span style="">订购增值</span
          ><span style=""
            >服务的用户，平台为您发送的所有通知均可通过平台站内消息、客户端推送、用户预留的电子邮件、手机短信或其他网络即时通讯工具传送等方式进行，</span
          ><span style=" font-weight: bold"
            >该等通知于发送之日视为已送达用户。请您应确保预留的联系方式为正确及有效，并在变更后及时告知平台内客服人员，如</span
          ><span style=" font-weight: bold">因您未提供</span
          ><span style=" font-weight: bold"
            >正确的联系信息或未及时告知新的联系方式，导致无法及时收取通知，将由您自行承担由此产生的损失及法律后果。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">3.【违约责任】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（1）您在使用</span
          ><span style="">本服务</span
          ><span style=""
            >的过程中，不得进行以下违约行为：</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">a. 违反本协议约定的；</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >b.
            违反法律、法规、规章、条例以及任何具有法律效力之规范规定的；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">c. 破坏、</span
          ><span style="">影响</span
          ><span style="">橙鹿“</span
          ><span style="">橙鹿”</span
          ><span style=""
            >平台对任何第三方提供本服务的；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >d. 进行危害计算机网络安全的行为；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">e. </span
          ><span style="">对</span
          ><span style="">橙鹿“</span
          ><span style="">橙鹿”</span
          ><span style=""
            >平台及关联第三方（包括授权方和合作方）提供的本协议服务、活动造成不良影响，侵犯关联第三方或其他用户的正当利益的；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >f. 被有关部门认定侵犯任何第三方的合法权益的；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">g. </span
          ><span style="">其他侵犯</span
          ><span style="">橙鹿“</span
          ><span style="">橙鹿”</span
          ><span style="">平台合法利益的行为。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（2）违约行为处理</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >您确认并同意，在发现违约行为后，</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台有权采取以下一项或多项措施处理：</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >a. 采取技术手段予以删除、屏蔽或断开相关的信息；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >b. 采取包括但不限于中止或终止部分或全部本服务；</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">c. </span
          ><span style="">橙鹿“</span
          ><span style="">橙鹿”</span
          ><span style=""
            >平台无需向您退还任何费用，未使用的服务费用作为违约金向</span
          ><span style="">橙鹿</span
          ><span style="">予以赔偿，您</span
          ><span style="">账号</span
          ><span style=""
            >内的损失（包括但不限于视频数据及虚拟产品的减少、灭失等）由您自行承担，造成</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台直接和间接损失的（包括但不限于律师费、诉讼费等），您也应予以赔偿。您的违约行为导致任何第三方损害的，您应当独立承担责任。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">4.【争议解决和法律适用】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（1）如就本协议内容或其执行发生任何争议，应尽量友好协商解决；</span
          ><span style=" font-weight: bold"
            >协商不成时，争议各方一致同意将发生的争议提交至本协议签订地湖北省武汉市东湖新技术开发区有管辖权的法院进行第一审管辖。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style=""
            >（2）本协议条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本协议条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">5.【其他】</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（1）本协议任</span
          ><span style="">一</span
          ><span style=""
            >条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</span
          >
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">（2）</span
          ><span style="">橙鹿</span
          ><span style=""
            >平台有权不经您同意即将其在本协议项下的全部权利义务部分或整体转让给</span
          ><span style="">任何</span
          ><span style="">橙鹿</span
          ><span style=""
            >的关联公司，但保证该转让行为不会影响或</span
          ><span style="">损害您</span
          ><span style="">之前享有的权利。</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <p
          style="
            margin-top: 0pt;
            margin-bottom: 0pt;
            text-align: justify;
            line-height: 125%;
            widows: 0;
            orphans: 0;
            font-size: 12pt;
          "
        >
          <span style="">&nbsp;</span>
        </p>
        <div style="-aw-headerfooter-type: footer-primary">
          <p
            style="
              margin-top: 0pt;
              margin-bottom: 0pt;
              text-align: center;
              widows: 0;
              orphans: 0;
              font-size: 9pt;
            "
          >
            <span
              style="
                height: 0pt;
                text-align: left;
                display: block;
                position: absolute;
                z-index: -65536;
              "
              ><img
                src="a0juc-87nge.001.png"
                width="91"
                height="17"
                alt=""
                style="
                  margin-left: 173.59pt;
                  -aw-left-pos: 0pt;
                  -aw-rel-hpos: margin;
                  -aw-rel-vpos: paragraph;
                  -aw-top-pos: 0pt;
                  -aw-wrap-type: none;
                  position: absolute;
                " /></span
            ><span style="font-family: Calibri">&nbsp;</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'service',
  data() {
    return {};
  },
  mounted() {
    this.changeTitle();
  },
  methods: {
    changeTitle() {
      document.title = '橙鹿用户增值服务协议';
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.agreement {
  height: 100%;
  background: #fff;
  font-size: 26px;
  color: #06112a;
  padding:20px 20px;
}
.title {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  line-height: 36px;
  padding: 30px 0 14px;
}
.agreement-p {
  padding: 0 32px;
}
.agreement-p p {
  line-height: 42px;
  text-align: justify;
}
.p2 {
  font-weight: 800;
}
.agreement-sub {
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/view/service.vue